module.exports = require('./helpers/bundle-url').getBundleURL('EVgbq') + "bg_main_image.89deacdd.jpg";